import { h } from 'preact'
import { useAppState } from '../state/Quiz.context'
import { WIZARD_NEXT } from '../state/actions/Wizard.actions'
import { useEffect } from 'preact/hooks'
/** @jsx h */

export const Next = ({ disabled }) => {
  const [{ wizard }, dispatch] = useAppState()

  useEffect(
    () => {
      return {
        disabled
      }
    },
    [disabled]
  )

  const onClick = () => {
    const index = Object.keys(wizard.history).findIndex(
      (v, i) => v === wizard.next
    )
    const next = Object.keys(wizard.history)[index + 1]
    dispatch({ type: WIZARD_NEXT, payload: next })
  }
  return (
    <button className="c-quiz__next-btn" onClick={onClick} disabled={disabled}>
      <span>{QuizSettings.localization.next}</span>
      <svg className="c-icon c-quiz__arrow-icon">
        <use href="#quiz-arrow-right" xlinkHref="#quiz-arrow-right" />
      </svg>
    </button>
  )
}



// WEBPACK FOOTER //
// ./src/js/quiz/components/Next.jsx